import AgentList from "../components/List/AgentList";
import { useAgents } from "../hooks/useAgents";

export default function AgentsPage() {
    const { loading } = useAgents();

    return (
        <div>
            {loading ? <p>Loading...</p> : <AgentList />}
        </div>
    );
}
